import { Component } from '@angular/core';

@Component({
  selector: 'app-dashboard-contabilidad',
  standalone: true,
  imports: [],
  templateUrl: './dashboard-contabilidad.component.html',
  styleUrl: './dashboard-contabilidad.component.scss',
})
export class DashboardContabilidadComponent {}
